import { BlogPostType } from "@nls-2022/nls-api";
import { FilterType } from "../nlsCommon";
import { ProcessingStatus } from "../nlsTypes";

export type BlogPostsState = {
  blogPosts: Array<BlogPostType> | null | undefined;
  blogPostsStatus: ProcessingStatus;
};

export enum BlogPostsActionType {
  BlogPostsFetchInit = "BLOGPOSTS_FETCH_INIT",
  BlogPostsFetchSuccess = "BLOGPOSTS_FETCH_SUCCESS",
  BlogPostsFetchFailure = "BLOGPOSTS_FETCH_FAILURE",
  BlogPostsFetchNotFound = "BLOGPOSTS_FETCH_NOTFOUND",
  BlogPostsNew = "BLOGPOSTS_NEW",
  BlogPostsRemoveClub = "BLOGPOSTS_REMOVE_CLUB",
  BlogPostsAddClub = "BLOGPOSTS_ADD_CLUB",
  BlogPostsSelected = "BLOGPOSTS_SELECTED",
  BlogPostsNotSelected = "BLOGPOSTS_NOT_SELECTED",
  BlogPostsAddClubFailure = "BLOGPOSTS_ADD_CLUB_FAILURE",
  FilteredBlogPosts = "BLOGPOSTS_FILTERED",
  BlogPostUpdatePublished = "BLOGPOST_UPDATEPUBLISHED",
  BlogPostsAddPost = "BLOGPOSTS_ADD_POST",
}

export type BlogPostsAction = {
  type: BlogPostsActionType;
  payload?: Array<BlogPostType> | null | undefined;
  actionPayload?:
    | {
        blogPost?: BlogPostType | null | undefined;
        blogPostId: string | null | undefined;
      }
    | null
    | undefined;
};

export type BlogPostsSearchPropType = {
  blogPosts: Array<BlogPostType> | null | undefined;
  resultType: "List" | "ByIndex";
  resultContext: "Search" | null | undefined;
  blogPostsDispatch: any;
  //handleFilteredBlogPostsUpdate: any;
};

export type BlogPostsListPropType = {
  blogPosts: Array<BlogPostType> | null | undefined;
  resultContext: "Search" | null | undefined;
  blogPostsDispatch: any;
};

export type BlogPostSearchByPublishedFlagType = {
  publishedFlag: boolean;
  handlePublishedFlagSearch: (
    event: React.ChangeEvent<HTMLInputElement>
  ) => void;
  children?: React.ReactNode;
};

export type BlogPostSearchByPubDateType = {
  pubDate: string;
  filterBy: FilterType;
  handlePubDateSearch: (event: React.ChangeEvent<HTMLInputElement>) => void;
  children?: React.ReactNode;
};
